import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import AdminLayout from "./components/AdminLayout";
import Dashboard from "./pages/Dashboard";
import Users from "./pages/Users";
import Login from "./pages/Login";
import Faqpage from "./pages/Faqpage";
import Mealgallery from "./pages/Mealgallery";
import Servicegallery from "./pages/Servicegallery";
import AddCountry from "./pages/AddCountry";
import AddMealCat from "./pages/AddMealCat";
import Pagenotfound from "./pages/Pagenotfound";
import { useDispatch } from "react-redux";
import { loadUserFromStorage } from "./redux/slices/authSlice";
import { useEffect } from "react";
import { Toaster } from "react-hot-toast";
import ProtectedRoute from "./components/ProtectedRoute";
import PublicRoute from "./components/PublicRoute";
import DevelopmentTag from "./components/Tags/DevelopmentTag";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import Manageinquiry from "./pages/Manageinquiry";

export default function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadUserFromStorage());
  }, []);

  function RedirectHandler() {
    const params = new URLSearchParams(window.location.search);
    const redirectPath = params.get("redirect");
    if (redirectPath) {
      window.history.replaceState(null, "", redirectPath);
    }
    return null;
  }

  return (
    <BrowserRouter>
      <RedirectHandler />
      <Toaster position="top-right" />
      <DevelopmentTag />
      <Routes>
        {/* Default route */}
        <Route path="/" element={<Navigate to="/users" replace />} />
        <Route path="*" element={<Navigate to="/404" replace />} />

        {/* PUBLIC ROUTES */}
        <Route
          path="/login"
          element={
            <PublicRoute>
              {/* ✅ Wrap Login inside the provider */}
              <GoogleReCaptchaProvider
                reCaptchaKey="6Le-uj8gAAAAABNGm_JUwhAy3BpxVjzGs5duNbjU"
                scriptProps={{
                  async: true,
                  defer: true,
                  appendTo: "body",
                }}
              >
                <Login />
              </GoogleReCaptchaProvider>
            </PublicRoute>
          }
        />

        <Route path="404" element={<Pagenotfound />} />

        {/* PROTECTED ROUTES */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          {/* <Route path="dashboard" element={<Dashboard />} /> */}
          <Route path="users" element={<Users />} />

          <Route path="faqs" element={<Faqpage />} />
          <Route path="manage-gallery/meal-gallery" element={<Mealgallery />} />
          <Route
            path="manage-gallery/service-gallery"
            element={<Servicegallery />}
          />
          <Route path="setting/add-country" element={<AddCountry />} />
          <Route path="setting/add-meal-category" element={<AddMealCat />} />
          <Route path="manage-inquiry" element={<Manageinquiry />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
